// Datamodel voor scenario's en blokken — zie §4 van het ontwerp.
// In Fase 1 alleen typedefinities; gebruikt in latere fases.

export type BlockType =
  | "gebouw"
  | "tuin"
  | "bestrating"
  | "boomstam"
  | "boombladdek";

export interface Block {
  id: string;
  name: string;
  type: BlockType;
  /** Polygoon als [lng, lat] paren in WGS84. */
  polygon: [number, number][];
  /** Hoogte bovenkant in meters boven maaiveld. */
  heightTop: number;
  /** Hoogte onderkant in meters (default 0; >0 voor bladdek). */
  heightBottom: number;
  /** Visuele transparantie 0–100 (puur weergave). */
  opacity?: number;
  /** Lichtdoorlatendheid 0–100 (rekenkundig; bv. boombladdek). */
  lightTransmission?: number;
  /** Hex kleur, bv. "#888888". */
  color: string;
}

export interface ScenarioView {
  centerLat: number;
  centerLng: number;
  zoom: number;
  rotation: number;
}

export interface Scenario {
  schemaVersion: number;
  id: string;
  name: string;
  description?: string;
  author?: string;
  createdAt: string;
  updatedAt: string;
  isPublic: boolean;
  view: ScenarioView;
  blocks: Block[];
}

export const CURRENT_SCHEMA_VERSION = 1;

// Standaardwaarden per bloktype — gebruikt bij het aanmaken van een nieuw blok.
// Hoogte-defaults volgen §7.1 van het ontwerp; kleuren zijn prettig herkenbaar
// op de luchtfoto en kunnen door de gebruiker worden aangepast.
export interface BlockTypeDefaults {
  label: string;
  heightTop: number;
  heightBottom: number;
  color: string;
  /** Lichtdoorlatendheid 0–100 (rekenkundig); undefined = niet relevant. */
  lightTransmission?: number;
  /** Kan dit type schaduw werpen? */
  castsShadow: boolean;
  /** Is dit een meetvlak (vangt schaduw op grondniveau)? */
  isMeasurementSurface: boolean;
}

export const BLOCK_TYPE_DEFAULTS: Record<BlockType, BlockTypeDefaults> = {
  gebouw: {
    label: "Gebouw",
    heightTop: 9,
    heightBottom: 0,
    color: "#7a8794",
    lightTransmission: 0,
    castsShadow: true,
    isMeasurementSurface: false,
  },
  tuin: {
    label: "Tuin",
    heightTop: 0,
    heightBottom: 0,
    color: "#5cae5c",
    castsShadow: false,
    isMeasurementSurface: true,
  },
  bestrating: {
    label: "Bestrating",
    heightTop: 0,
    heightBottom: 0,
    color: "#b9b3a8",
    castsShadow: false,
    isMeasurementSurface: true,
  },
  boomstam: {
    label: "Boomstam",
    heightTop: 4,
    heightBottom: 0,
    color: "#7d4e2a",
    lightTransmission: 0,
    castsShadow: true,
    isMeasurementSurface: false,
  },
  boombladdek: {
    label: "Boombladdek",
    heightTop: 8,
    heightBottom: 3,
    color: "#3c8d3c",
    lightTransmission: 40,
    castsShadow: true,
    isMeasurementSurface: false,
  },
};

